import { render, staticRenderFns } from "./change_payPassword.vue?vue&type=template&id=ff507a36&scoped=true"
import script from "./change_payPassword.vue?vue&type=script&lang=js"
export * from "./change_payPassword.vue?vue&type=script&lang=js"
import style0 from "./change_payPassword.vue?vue&type=style&index=0&id=ff507a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff507a36",
  null
  
)

export default component.exports